import { render, staticRenderFns } from "./InsensitiveAnonymisation.vue?vue&type=template&id=6cb00eba&"
import script from "./InsensitiveAnonymisation.vue?vue&type=script&lang=ts&"
export * from "./InsensitiveAnonymisation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports